import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/soyuz/client';

import { DSIcon } from '../../../base';
import Dropdown from '../Dropdown';
import DropdownItem from '../DropdownItem';

import linkShape from './shapes/link.shape';
import themeShape, { DARK_THEME, LIGHT_THEME } from './shapes/theme.shape';

const HeaderSupportCenter = ({ color = DARK_THEME, supportCenter = {} }) => (
  <Dropdown
    title={supportCenter.label || trans('menu.support-center.title')}
    position="right"
    color="light"
    textTransform="capitalize"
    arrowIcon
    data-test="header-nav-support-center"
    className={color === LIGHT_THEME ? 'menu-transparent' : 'menu-white'}
    {...supportCenter}
  >
    <DropdownItem className="ga-my-profile">
      <a href={getPagePath('support')}>
        <div className="dropdown-item__text">
          <DSIcon name="support_agent" className="dropdown-item__icon" />
          {trans('menu.support-center.contact-us')}
        </div>
      </a>
    </DropdownItem>

    <DropdownItem className="ga-search-preference">
      <a href={getPagePath('externals.help-center')}>
        <div className="dropdown-item__text">
          <DSIcon name="map" className="dropdown-item__icon" />
          {trans('menu.support-center.help-guide')}
        </div>
      </a>
    </DropdownItem>
  </Dropdown>
);

HeaderSupportCenter.propTypes = {
  color: themeShape,
  supportCenter: PropTypes.shape(linkShape)
};

export default HeaderSupportCenter;
